export const SIGNUP_ADMIN_USER = "SIGNUP_ADMIN_USER"
export const SIGNUP_ADMIN_USER_SUCCESS = "SIGNUP_ADMIN_USER_SUCCESS"
export const SIGNUP_ADMIN_USER_ERROR = "SIGNUP_ADMIN_USER_ERROR"